import createTaskProcessorWorker from "./createTaskProcessorWorker.js";
import Transforms from "../Core/Transforms.js";
import defined from "../Core/defined.js";
import BoundingSphere from "../Core/BoundingSphere.js";
import Cartesian3 from "../Core/Cartesian3.js";
import Quaternion from "../Core/Quaternion.js";
import Matrix4 from "../Core/Matrix4.js";
import IndexDatatype from "../Core/IndexDatatype.js";
import Color from "../Core/Color.js";
import CesiumMath from "../Core/Math.js";
import Cartesian4 from "../Core/Cartesian4.js";

function calcTraceMesh(parameters, transferableObjects) {
  var ribbons = parameters.ribbons;
  //记录最大轨迹点数
  var MAXPOINTS_NUM_PRE_ALLPATH	=	5000;
  //目标临近多少点不抽稀
  var NO_SPARSE_PONITS_NUM	=	100;
   //抽稀轨迹最大点数
  var MAXPOINTS_NUM_PRE_SPARSEPATH = 300;
  var transformFunc = Transforms.localFrameToFixedFrameGenerator("north", "west");
  var scratchModelMat4 = new Matrix4();

  var length = ribbons.length;
  var vertexRibbons = [];
  var vertexCount = 0;
  var indexCount = 0;

  for (var i=0; i<length; i++ ){
    if(defined(ribbons[i]) && ribbons[i].trackPoints.length > 1){
      ribbons[i].scale =
        CesiumMath.equalsEpsilon(ribbons[i].scale, 0.0, CesiumMath.EPSILON7) ? 1.0 : ribbons[i].scale;
      var realForwardOffsetScale =  1.0/ribbons[i].scale;
      var scale = ribbons[i].scale;
      var trackPoints = ribbons[i].trackPoints;
      var verPts = [];
      //靠近目标的 NO_SPARSE_PONITS_NUM 点保留，抽稀其他点
      var ptLength = trackPoints.length;
      if(ptLength > MAXPOINTS_NUM_PRE_SPARSEPATH){
        var thiningCount = ptLength - NO_SPARSE_PONITS_NUM;
        var multiple = Math.floor(thiningCount / (MAXPOINTS_NUM_PRE_SPARSEPATH - NO_SPARSE_PONITS_NUM)) + 1;
        var sparseCount = ptLength-NO_SPARSE_PONITS_NUM-multiple;
        var index = 0;
        for(;index < sparseCount; index+=multiple){
          var quat = Quaternion.fromHeadingPitchRoll(trackPoints[index].headingPitchRoll, new Quaternion());
          var rotMat4 = Matrix4.fromTranslationQuaternionRotationScale(new Cartesian3(0.0, 0.0, 0.0), quat, new Cartesian3(scale, scale, scale));
          scratchModelMat4 = transformFunc(trackPoints[index].wcPosition, undefined, scratchModelMat4);
          scratchModelMat4 = Matrix4.multiply(scratchModelMat4, rotMat4, scratchModelMat4);
          var normal = Matrix4.multiplyByPoint(scratchModelMat4, new Cartesian3(0.0, 0.0, 1.0), new Cartesian3());
          normal = Cartesian3.subtract(normal, trackPoints[index].wcPosition, normal);
          var sideLPos = Matrix4.multiplyByPoint(scratchModelMat4, new Cartesian3(ribbons[i].forwardOffset * realForwardOffsetScale, ribbons[i].upOffset, 0.0), new Cartesian3());
          var sideRPos = Matrix4.multiplyByPoint(scratchModelMat4, new Cartesian3(ribbons[i].forwardOffset * realForwardOffsetScale, -ribbons[i].upOffset, 0.0), new Cartesian3());
          verPts.push({
            position:sideLPos,
            normal:normal
          });
          verPts.push({
            position:sideRPos,
            normal:normal
          });
          vertexCount+=2;
        }

        for (;index < ptLength-1; index++){
          var quat = Quaternion.fromHeadingPitchRoll(trackPoints[index].headingPitchRoll, new Quaternion());
          var rotMat4 = Matrix4.fromTranslationQuaternionRotationScale(new Cartesian3(0.0, 0.0, 0.0), quat, new Cartesian3(scale, scale, scale));
          scratchModelMat4 = transformFunc(trackPoints[index].wcPosition, undefined, scratchModelMat4);
          scratchModelMat4 = Matrix4.multiply(scratchModelMat4, rotMat4, scratchModelMat4);
          var normal = Matrix4.multiplyByPoint(scratchModelMat4, new Cartesian3(0.0, 0.0, 1.0), new Cartesian3());
          normal = Cartesian3.subtract(normal, trackPoints[index].wcPosition, normal);
          var sideLPos = Matrix4.multiplyByPoint(scratchModelMat4, new Cartesian3(ribbons[i].forwardOffset * realForwardOffsetScale, ribbons[i].upOffset, 0.0), new Cartesian3());
          var sideRPos = Matrix4.multiplyByPoint(scratchModelMat4, new Cartesian3(ribbons[i].forwardOffset * realForwardOffsetScale, -ribbons[i].upOffset, 0.0), new Cartesian3());
          verPts.push({
            position:sideLPos,
            normal:normal
          });
          verPts.push({
            position:sideRPos,
            normal:normal
          });
          vertexCount+=2;
        }
      }else{
        for (var j=0; j< trackPoints.length; j++){
          var quat = Quaternion.fromHeadingPitchRoll(trackPoints[j].headingPitchRoll, new Quaternion());
          var rotMat4 = Matrix4.fromTranslationQuaternionRotationScale(new Cartesian3(0.0, 0.0, 0.0), quat, new Cartesian3(scale, scale, scale));
          scratchModelMat4 = transformFunc(trackPoints[j].wcPosition, undefined, scratchModelMat4);
          scratchModelMat4 = Matrix4.multiply(scratchModelMat4, rotMat4, scratchModelMat4);
          var normal = Matrix4.multiplyByPoint(scratchModelMat4, new Cartesian3(0.0, 0.0, 1.0), new Cartesian3());
          normal = Cartesian3.subtract(normal, trackPoints[j].wcPosition, normal);
          var sideLPos = Matrix4.multiplyByPoint(scratchModelMat4, new Cartesian3(ribbons[i].forwardOffset * realForwardOffsetScale, ribbons[i].upOffset, 0.0), new Cartesian3());
          var sideRPos = Matrix4.multiplyByPoint(scratchModelMat4, new Cartesian3(ribbons[i].forwardOffset * realForwardOffsetScale, -ribbons[i].upOffset, 0.0), new Cartesian3());
          verPts.push({
            position:sideLPos,
            normal:normal
          });
          verPts.push({
            position:sideRPos,
            normal:normal
          });
          vertexCount+=2;
        }
      }
      vertexRibbons.push(verPts);
      indexCount+=(verPts.length/2-1)*6;
    }
  }

  if(vertexRibbons.length == 0){
    return;
  }
  var boundingSphere = new BoundingSphere();
  var indices = IndexDatatype.createTypedArray(vertexCount, indexCount);
  var position = new Float64Array(vertexCount * 3);
  var normal = new Float64Array(vertexCount * 3);
  var colorBuffer = new Uint8Array(vertexCount * 4);

  var ptIndex = 0;
  var rIndexNums = 0;
  for (var i=0; i<vertexRibbons.length; i++){
    var color = ribbons[i].color;
    var verPts = vertexRibbons[i];
    var verPtLength = verPts.length;
    //创建顶点buffer
    for (var m=0; m<verPtLength; m++){
      boundingSphere = BoundingSphere.expand(boundingSphere, verPts[m].position);

      position[(rIndexNums+m)*3] =  verPts[m].position.x;
      position[(rIndexNums+m)*3+1] =verPts[m].position.y;
      position[(rIndexNums+m)*3+2] =verPts[m].position.z;

      normal[(rIndexNums+m)*3] =  verPts[m].normal.x;
      normal[(rIndexNums+m)*3+1] =verPts[m].normal.y;
      normal[(rIndexNums+m)*3+2] =verPts[m].normal.z;

      var colorRatio = 1.0 - (verPtLength-m) / verPtLength*1.0;
      colorBuffer[(rIndexNums+m)*4] =   Color.floatToByte(color.red);
      colorBuffer[(rIndexNums+m)*4+1] = Color.floatToByte(color.green);
      colorBuffer[(rIndexNums+m)*4+2] = Color.floatToByte(color.blue);
      colorBuffer[(rIndexNums+m)*4+3] = Color.floatToByte(color.alpha * colorRatio);
    }

    //创建顶点索引
    for (var n=0; (n+3)<verPtLength; n+=2){
      indices[ptIndex++] = rIndexNums + n;
      indices[ptIndex++] = rIndexNums + n+1;
      indices[ptIndex++] = rIndexNums + n+2;

      indices[ptIndex++] = rIndexNums + n+1;
      indices[ptIndex++] = rIndexNums + n+3;
      indices[ptIndex++] = rIndexNums + n+2;
    }
    rIndexNums += verPtLength;
  }

  //清空
  parameters.ribbons = undefined;

  return {
    positionBuffer:position.buffer,
    normalBuffer:normal.buffer,
    colorBuffer:colorBuffer.buffer,
    indices:indices.buffer,
    boundingSphere:boundingSphere,
  };
}

export default createTaskProcessorWorker(calcTraceMesh);